import { createEntityAdapter } from '@reduxjs/toolkit';

const billingAccountsAdapter = createEntityAdapter();

export default billingAccountsAdapter;
